import { render } from "./CreateAudience.vue?vue&type=template&id=74357da6&scoped=true"
import script from "./CreateAudience.vue?vue&type=script&lang=js"
export * from "./CreateAudience.vue?vue&type=script&lang=js"

import "./CreateAudience.vue?vue&type=style&index=0&id=74357da6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74357da6"]])

export default __exports__